import * as React from "react";
import { PureComponent } from "react";
import "./style.scss";
import AppContext from "../../context/AppContext";
import OpisWyjazduData from "../OpisWyjazduData";
import OpisWyjazduLoty from "../OpisWyjazduLoty";
import OpisWyjazduMiejsca from "../OpisWyjazduMiejsca";
import OpisWyjazduOpis from "../OpisWyjazduOpis";
import OpisWyjazduGalerie from "../OpisWyjazduGalerie";
import OpisWyjazduRelacje from "../OpisWyjazduRelacje";

class OpisWyjazdu extends PureComponent<any> {
  static contextType = AppContext;

  render() {
    const { trip } = this.props;
    return (
      <div className="OpisWyjazdu">
        <OpisWyjazduData date={trip.date} />
        <OpisWyjazduLoty routes={trip.routes} />
        <OpisWyjazduMiejsca places={trip.places} />
        <OpisWyjazduOpis description={trip.description} />
        <OpisWyjazduGalerie galleries={trip.galleries} />
        <OpisWyjazduRelacje reports={trip.reports} />
      </div>
    );
  }
}

export default OpisWyjazdu;
